<div class="form--apto-ionic-select">
    <ion-label stacked>State/Province</ion-label>
    <apto-ionic-select [value]="displayValue"
                       (onSelectOption)="setFormValue($event)"
                       [options]="values()"
                       [cssClass]="cssClass"></apto-ionic-select>
</div>
